import { Injectable }               from '@angular/core';
import { Observable }               from 'rxjs/Observable';
import { Response }                 from '@angular/http';

import { Journey }                  from './../../models/journey/journey';
import { JourneyDetail }            from './../../models/journey/journey-detail';
import { JourneyStep }              from './../../models/journey-editor/journey-step';
import { StepOptions }              from './../../models/journey-editor/step-options';

import { ApiService }               from '../../root-services/api.service';

@Injectable()

export class JourneysService {

  _journeys: Observable<Journey[]> = null;
  _journey: Observable<JourneyDetail> = null;
  _journeySteps: Observable<JourneyStep[]> = null;
  _stepOptions: Observable<StepOptions> = null;

  constructor(private api: ApiService) { }

  getJourneys(): Observable<Journey[]> {
    if (!this._journeys) {
      this._journeys = this.api.get('/journeys')
                         .map((response: Response) => response.json() as Journey[])
                         .publishReplay(1).refCount()
                         .catch(this.handleError);
    }

    return this._journeys;
  }

  getJourney(id, reload?: boolean): Observable<JourneyDetail> {
    if (!this._journey || reload) {
      this._journey = this.api.get(`/journeys/${id}`)
                         .map((response: Response) => response.json() as JourneyDetail)
                         .publishReplay(1).refCount()
                         .catch(this.handleError);
    }

    return this._journey;
  }

  getJourneySteps(id): Observable<JourneyStep[]> {
    if (!this._journeySteps) {
      this._journeySteps = this.api.get(`/journeys/${id}/steps`)
                         .map((response: Response) => response.json() as JourneyStep[])
                         .publishReplay(1).refCount()
                         .catch(this.handleError);
    }

    return this._journeySteps;
  }

  getJourneyStepOptions(): Observable<StepOptions> {
    if (!this._stepOptions) {
      this._stepOptions = this.api.get(`/journeys/steps/options`)
                         .map((response: Response) => response.json() as StepOptions)
                         .publishReplay(1).refCount()
                         .catch(this.handleError);
    }
    return this._stepOptions;
  }

  public deleteUsers(journeyId: number, user_ids: number[]): Observable<number[]> {
    const body = { user_ids: user_ids, action: 'delete' };
    return this.handleUserAction(journeyId, body);
   }

  public addUsers(journeyId: number, user_ids: number[]): Observable<{added: string}> {
    const body = { user_ids: user_ids, action: 'add' };
    return this.handleUserAction(journeyId, body);
  }

  public reorderJourneySteps(journeyId: number, steps: JourneyStep[]): Observable<JourneyStep[]> {
    return this.api.put(`/journeys/${journeyId}/steps`, {'steps': steps})
      .map((response: Response) => response.json() as JourneyStep[])           
      .publishReplay(1).refCount()
      .catch(this.handleError);
  }

  public submitJourneyEdits(journey: JourneyDetail): Observable<void> {
    const body = { journey: journey };
    return this.api.put(`/journeys/${journey.id}/editor`, body)
      .publishReplay(1).refCount()
      .catch(this.handleError);
  }

  public submitNewJourney(journey: JourneyDetail): Observable<Journey> {
    const body = { journey: journey };
    return this.api.post(`/journeys/new`, body)
      .map((response: Response) => response.json() as Journey)           
      .publishReplay(1).refCount()
      .catch(this.handleError);
  }

  public cloneJourney(journeyId: number, editionId: number, override: boolean): Observable<{id: number, alerts:string[]}> {
    const body = {
      edition_id: editionId,
      override_alerts: override
    }
    return this.api.post(`/journeys/${journeyId}/actions/duplicate`, body)
      .map((response: Response) => response.json() as {id: number, alerts: {step_id: number, alert: string}[]})
      .publishReplay(1).refCount()
      .catch(this.handleError);
  }

  public getCloneableJourneys(): Observable<{id: number, name: string, edition: {id: number, name: string}}[]> {
    return this.api.get('/cloneable-journeys')
      .map((response: Response) => response.json() as {id: number, name: string, edition: {id: number, name: string}}[])
      .publishReplay(1).refCount()
      .catch(this.handleError);
  }

  public deleteJourney(journeyId: number): Observable<number> {
    return this.api.delete(`/journeys/${journeyId}/editor`)
      .map((response: Response) => response.json())           
      .publishReplay(1).refCount()
      .catch(this.handleError);
  }

  public deleteStep(journeyId: number, stepId: number): Observable<void> {
    return this.api.delete(`/journeys/${journeyId}/step_editor/${stepId}`)
      .map((response: Response) => response.json())
      .publishReplay(1).refCount()
      .catch(this.handleError);
  }

  public submitJourneyStepEdits(journeyId: number, step: JourneyStep): Observable<JourneyStep> {
    return this.api.put(`/journeys/${journeyId}/step_editor`, step)
      .map((response: Response) => response.json() as JourneyStep)           
      .publishReplay(1).refCount()
      .catch(this.handleError);
  }

  private handleUserAction(journeyId: number, body: object) {
    return this.api.post(`/journeys/${journeyId}/users`, body)
      .map((response: Response) => response.json() as number[])
      .publishReplay(1).refCount()
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/journeys/journeys.service.ts